import Title from './Layout'

export default Title
